import { buildLoginPageURL } from './Login'

export const buildRegistrationURL = ({ loginLocation, clientId, returnURL }) => {
  return buildLoginPageURL({ clientId, returnURL, loginLocation })
}
